// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationBar_container__89WRq","closeIcon":"NotificationBar_closeIcon__AhdeY","success":"NotificationBar_success__POI69","alert":"NotificationBar_alert__P0vfN"};